import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import ContactForm from './ContactForm';
import CreateOrganisationContactService from '../../services/contacts/createOrganisationContactService';
import { mapContact } from '../../helpers/contacts/mapContact';

const EMPTY_ORG_CONTACT = { emailAddress: '', phoneNumber: '' };

const NewContact = ({
  open,
  dispatchCreateOrganisationContactPost,
  createOrganisationContactFetch,
  organisationId,
  returnRoute,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleSubmit = useCallback(
    body =>
      dispatchCreateOrganisationContactPost(
        organisationId,
        mapContact(body),
        () => navigate(returnRoute),
        t
      ),
    [dispatchCreateOrganisationContactPost, organisationId, returnRoute, navigate, t]
  );

  if (!open) return null;

  return (
    <ContactForm
      header={t('newContact')}
      onSubmit={handleSubmit}
      submitProcessing={createOrganisationContactFetch.pending}
      returnRoute={returnRoute}
      cancelRoute={returnRoute}
      data={EMPTY_ORG_CONTACT}
    />
  );
};

NewContact.propTypes = {
  dispatchCreateOrganisationContactPost: PropTypes.func.isRequired,
  createOrganisationContactFetch: PropTypes.object.isRequired,
  organisationId: PropTypes.string.isRequired,
  returnRoute: PropTypes.string.isRequired,
  open: PropTypes.bool,
};

NewContact.defaultProps = { open: false };

export default CreateOrganisationContactService(NewContact);
